module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-bia-50a1b7ff1a7b66c70ab08d7261826db3.png";